import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface SubMenuItemProps {
  text?: string | React.ReactNode;
  disabled?: boolean;
  containerClassName?: string;
  itemClassName?: string;
  textClassName?: string;
  leftIconContainerClassName?: string;
  leftIconClassName?: string;
  to?: string;
  onClick?: () => void;
}

export const SubMenuItem = ({
  text,
  disabled,
  containerClassName,
  itemClassName,
  textClassName,
  leftIconContainerClassName,
  leftIconClassName,
  to,
  onClick,
}: SubMenuItemProps) => {
  const MenuItem = to ? Link : 'div';

  return (
    <MenuItem
      data-menu-dismiss="true"
      className={twMerge(
        'menu-item group/sub-menu-item',
        containerClassName,
        disabled && 'disabled'
      )}
      to={to}
      onClick={disabled ? () => {} : onClick}
    >
      <div
        className={twMerge(
          'menu-link !py-[4px] flex items-center',
          itemClassName,
          disabled && 'hover:cursor-not-allowed'
        )}
      >
        <div
          className={twMerge(
            'flex items-center min-w-[25px]',
            leftIconContainerClassName
          )}
        >
          <i
            className={twMerge(
              'ki-outline',
              disabled && 'text-gray-600',
              leftIconClassName
            )}
          />
        </div>
        {text && (
          <div
            className={twMerge(
              'mt-[4px] text-[12.5px] font-medium flex items-center',
              disabled && 'text-gray-700',
              textClassName
            )}
          >
            {text}
          </div>
        )}
      </div>
    </MenuItem>
  );
};
